export default __webpack_public_path__ + "static/media/team6.573995d7.png";